<template>
<!-- 20190911同人攻略迁移至资讯，v4和doujin数据共用本组件展示，增加字段匹配 -->
    <div class="igc-v4-video"
        :style="{ 'background': mColor(7) }"
        @click="to" v-dmp="{action:'click,pop', targetid: item.iId||item.iVideoId ||item.vid, targettype: 'video', title: item.sTitle||item.articleTitle, from:item.iBiz?'v4':'doujin'}">
        <div class="ig--info">
            <div class="ig--title" :style="{ 'color': mColor(1) }">{{ item.sTitle||item.articleTitle }}</div>
            <div class="ig--desc" :style="{ 'color': mColor(3) }">
                <sui-icon :fill="mColor(3)"
                    name="eye-outline"></sui-icon>
                {{ item.iTotalPlay||item.totalVV | mcFormatNumber }}
            </div>
        </div>
        <div class="ig--poster">
            <div class="ig--icon"></div>
            <sui-image :src="mImageView(item.sIMG||item.imgUrl, '/1/w/315/h/210')"></sui-image>
        </div>
    </div>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-v4-video',

    mixins: [mCore],

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        to() {
            let id = this.item.iId || this.item.iVideoId || this.item.articleId

            /* #region 埋点 */
            this.mEventTracking('list_video', '列表_视频', {
                id
            })
            // this.mEventTrackingToDMP({
            //     action: 'click',
            //     sourceid: id,
            //     targetid: id,
            //     targettype: 'video',
            //     tag: '',
            //     title: this.item.sTitle
            // })
            /* #endregion */
            this.$router.push({
                name: this.item.articleId?'doujin-detail-video':'detail-video',
                params: {
                    id
                }
            })
        }
    }
}
</script>

<style lang="postcss">
.igc-v4-video {
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    height: 224px;
    margin-top: 20px;
    padding: 20px;
    @media (orientation: portrait) {
        width: 100%;
    }
    @media (orientation: landscape) {
        width: calc((100% - 20px) / 2);
    }
    .ig--info {
        flex: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        .ig--title {
            display: -webkit-box;
            /* autoprefixer: ignore next */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            font-size: 32px;
        }
        .ig--desc {
            display: flex;
            align-items: center;
            font-size: 24px;
            .sui-icon {
                width: 36px;
                height: 36px;
                margin-right: 6px;
            }
        }
    }
    .ig--poster {
        flex: none;
        position: relative;
        width: 210px;
        height: 140px;
        margin-left: 20px;
        .ig--icon {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
            width: 54px;
            height: 54px;
            background: url(../../images/play.png) no-repeat center / contain;
            transform: translate3d(-50%, -50%, 0);
        }
        .sui-image {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
